export type MaritalStatusCode = 'm' | 's' | 'd' | 'w';

export type MaritalStatusValue = 'married' | 'single' | 'divorced' | 'widowed';

export const MaritalStatusConstants: Record<
  MaritalStatusValue,
  MaritalStatusCode
> = {
  married: 'm',
  single: 's',
  divorced: 'd',
  widowed: 'w',
};

export type MaritalStatusEntry = { key: MaritalStatusCode; label: string };

export const MaritalStatusEntries: MaritalStatusEntry[] = [
  { key: 'm', label: 'Married' },
  { key: 's', label: 'Single' },
  { key: 'd', label: 'Divorced' },
  { key: 'w', label: 'Widowed' },
];

export const MaritalStatusLookup: Record<
  MaritalStatusCode,
  MaritalStatusEntry
> = MaritalStatusEntries.reduce(
  (m, v) => {
    m[v.key] = v;

    return m;
  },
  {} as Record<MaritalStatusCode, MaritalStatusEntry>,
);
